import loadSessionModule from './modules/Session.module';
const loadGuestRedirectModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule()],
});
export default loadGuestRedirectModule;
